export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11641.f092b23a.jpg";